import React, {useState} from "react";
import {URL} from "../link";

export function Button({ children, className, buttonTypes, onClick, disableDuringOnClick = false, ...props }) {
    const [ disabled, setDisabled ] = useState(false);

    if (disableDuringOnClick) {
        const originalOnClick = onClick;
        onClick = async (...args) => {
            setDisabled(true);
            await originalOnClick(...args);
            setDisabled(false);
        }
    }

    const fullClassName = 'btn ' + (className ?? '') + ' ' + (buttonTypes ?? []).join(' ');
    return <button disabled={(props.disabled ?? false) || disabled} className={fullClassName} onClick={onClick} {...props}>{children}</button>;
}

export function LinkButton({ children, href, className, buttonTypes, ...props }) {
    const fullClassName = 'btn ' + (className ?? '') + ' ' + (buttonTypes ?? []).join(' ');
    return <URL href={href} className={fullClassName} {...props}>{children}</URL>;
}

export function ButtonGroup({ children, className, ...props }) {
    return <div className={'btn-group ' + (className ?? '')} {...props}>{children}</div>
}

export const ButtonTypes = {
    success: 'btn-success',
    error: 'btn-error',
    primary: 'btn-primary',
    disabled: 'disabled',
    loading: 'loading',
    small: 'btn-sm',
    verySmall: 'btn-xs',
    medium: '',
    large: 'btn-lg',
    link: 'btn-link',
    fullWidth: 'btn-full-width'
};
